(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Scanner_1 = __webpack_require__(1);
var Watcher_1 = __webpack_require__(3);
var Renderer_1 = __webpack_require__(4);
var Loader_1 = __webpack_require__(5);
var ComponentGenerator_1 = __webpack_require__(7);
exports.SegmentFault = (function () {
    function SegmentFault() {
        this.viewModelPool = {};
        this.viewViewModelMap = {};
        this.renderer = new Renderer_1.Renderer();
        this.componentPool = {};
    }
    SegmentFault.prototype.init = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var loader = new Loader_1.Loader(_this.componentPool);
            loader.load().then(function (componentDefinitionPool) {
                console.log(componentDefinitionPool);
                if (componentDefinitionPool) {
                    _this.generator = new ComponentGenerator_1.ComponentGenerator(_this, componentDefinitionPool);
                    return _this.generator.scanComponent(document);
                }
                else {
                    return;
                }
            }).then(function () {
                var scanner = new Scanner_1.Scanner(_this.viewModelPool);
                var watcher = new Watcher_1.Watcher(_this);
                for (var key in _this.viewModelPool) {
                    watcher.observe(_this.viewModelPool[key], _this.viewModelChangedHandler);
                }
                _this.viewViewModelMap = scanner.scanBindDOM();
                Object.keys(_this.viewViewModelMap).forEach(function (alias) {
                    _this.refresh(alias);
                });
                resolve();
            });
        });
    };
    ;
    SegmentFault.prototype.registerViewModel = function (alias, viewModel) {
        viewModel["_alias"] = alias;
        window[alias] = this.viewModelPool[alias] = viewModel;
    };
    ;
    SegmentFault.prototype.refresh = function (alias) {
        var _this = this;
        var boundItems = this.viewViewModelMap[alias];
        boundItems.forEach(function (boundItem) {
            _this.renderer.render(boundItem);
        });
    };
    SegmentFault.prototype.viewModelChangedHandler = function (viewModel, prop) {
        this.refresh(viewModel._alias);
    };
    SegmentFault.prototype.registerComponent = function (tagName, path) {
        this.componentPool[tagName] = path;
    };
    return SegmentFault;
}());


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BoundItem_1 = __webpack_require__(2);
var Scanner = (function () {
    function Scanner(viewModelPool) {
        this.prefix = "sf-";
        this.viewModelPool = viewModelPool;
    }
    Scanner.prototype.scanBindDOM = function () {
        var _this = this;
        var boundMap = {};
        var boundElements = this.getAllBoundElements(this.prefix);
        boundElements.forEach(function (element) {
            for (var i = 0; i < element.attributes.length; i++) {
                var attr = element.attributes[i];
                if (attr.nodeName.search(_this.prefix) > -1) {
                    var attributeName = attr.nodeName;
                    var expression = element.getAttribute(attributeName);
                    for (var alias in _this.viewModelPool) {
                        if (expression.search(alias + ".") != -1) {
                            var boundItem = new BoundItem_1.BoundItem(_this.viewModelPool[alias], element, expression, attributeName);
                            if (!boundMap[alias]) {
                                boundMap[alias] = [boundItem];
                            }
                            else {
                                boundMap[alias].push(boundItem);
                            }
                        }
                    }
                }
            }
        });
        return boundMap;
    };
    Scanner.prototype.fuzzyFind = function (element, text) {
        if (element && element.attributes) {
            for (var i = 0; i < element.attributes.length; i++) {
                var attr = element.attributes[i];
                if (attr.nodeName.search(text) > -1) {
                    return element;
                }
            }
        }
        return null;
    };
    Scanner.prototype.getAllBoundElements = function (prefix) {
        var elements = [];
        var allChildren = document.querySelectorAll("*");
        for (var i = 0; i < allChildren.length; i++) {
            var child = allChildren[i];
            var matchElement = this.fuzzyFind(child, prefix);
            if (matchElement) {
                elements.push(matchElement);
            }
        }
        return elements;
    };
    return Scanner;
}());
exports.Scanner = Scanner;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BoundItem = (function () {
    function BoundItem(viewModel, element, expression, attributeName) {
        this.interactiveDomConfig = {
            "INPUT": {
                "text": "input",
                "password": "input",
                "email": "input",
                "url": "input",
                "tel": "input",
                "radio": "change",
                "checkbox": "change",
                "color": "change",
                "date": "change",
                "datetime": "change",
                "datetime-local": "change",
                "month": "change",
                "number": "change",
                "range": "change",
                "search": "change",
                "time": "change",
                "week": "change",
                "button": "N/A",
                "submit": "N/A"
            },
            "SELECT": "change",
            "TEXTAREA": "change"
        };
        this.viewModel = viewModel;
        this.element = element;
        this.expression = expression;
        this.attributeName = attributeName;
        this.addListener(this.element, this.expression);
    }
    BoundItem.prototype.addListener = function (element, expression) {
        var tagName = element.tagName;
        var eventName = this.interactiveDomConfig[tagName];
        if (!eventName) {
            return;
        }
        if (typeof eventName === "object") {
            var type = element.getAttribute("type");
            eventName = eventName[type];
        }
        element.addEventListener(eventName, function (e) {
            var newValue = element.value;
            var cmd = expression + "= \"" + newValue + "\"";
            try {
                eval(cmd);
            }
            catch (e) {
                console.error(e);
            }
        });
    };
    return BoundItem;
}());
exports.BoundItem = BoundItem;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Watcher = (function () {
    function Watcher(sf) {
        this.sf = sf;
    }
    Watcher.prototype.observe = function (viewModel, callback) {
        var host = this.sf;
        for (var key in viewModel) {
            var defaultValue = viewModel[key];
            (function (k, dv) {
                if (k !== "_alias") {
                    Object.defineProperty(viewModel, k, {
                        get: function () {
                            return dv;
                        },
                        set: function (value) {
                            dv = value;
                            console.log("do something after set a new value");
                            callback.call(host, viewModel, k);
                        }
                    });
                }
            })(key, defaultValue);
        }
    };
    return Watcher;
}());
exports.Watcher = Watcher;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Renderer = (function () {
    function Renderer() {
    }
    Renderer.prototype.render = function (boundItem) {
        var value = this.getValue(boundItem.viewModel, boundItem.expression);
        var attribute = boundItem.attributeName.split('-')[1];
        if (attribute.toLowerCase() === "innertext") {
            attribute = "innerText";
        }
        boundItem.element[attribute] = value;
    };
    ;
    Renderer.prototype.getValue = function (viewModel, expression) {
        return (function () {
            var alias = viewModel._alias;
            var tempScope = {};
            tempScope[alias] = viewModel;
            try {
                var pattern = new RegExp("\\b" + alias + "\\b", "gm");
                expression = expression.replace(pattern, "tempScope." + alias);
                var result = eval(expression);
                tempScope = null;
                return result;
            }
            catch (e) {
                throw e;
            }
        })();
    };
    return Renderer;
}());
exports.Renderer = Renderer;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ComponentDefinition_1 = __webpack_require__(6);
var Loader = (function () {
    function Loader(componentPool) {
        this.componentDefinitionPool = {};
        this.componentPool = componentPool;
    }
    Loader.prototype.load = function () {
        var compArray = [];
        for (var tagName in this.componentPool) {
            compArray.push({ name: tagName, path: this.componentPool[tagName] });
        }
        return this.doAsyncSeries(compArray).then(function (result) {
            return result;
        });
    };
    Loader.prototype.doAsyncSeries = function (componentArray) {
        var _this = this;
        return componentArray.reduce(function (promise, comp) {
            return promise.then(function (result) {
                return fetch(comp.path).then(function (response) {
                    return response.text().then(function (definition) {
                        var def = _this.getComponentDefinition(comp.name, definition);
                        _this.componentDefinitionPool[comp.name] = def;
                        return _this.componentDefinitionPool;
                    });
                });
            });
        }, new Promise(function (resolve, reject) {
            resolve();
        }));
    };
    Loader.prototype.getComponentDefinition = function (tagName, htmlString) {
        var tempDom = document.createElement("div");
        tempDom.innerHTML = htmlString;
        var template = tempDom.querySelectorAll("template")[0] && tempDom.querySelectorAll("template")[0].innerHTML;
        var script = tempDom.querySelectorAll("script")[0] && tempDom.querySelectorAll("script")[0].innerHTML;
        var style = tempDom.querySelectorAll("style")[0] && tempDom.querySelectorAll("style")[0].innerHTML;
        return new ComponentDefinition_1.ComponentDefinition(tagName, style, template, script);
    };
    return Loader;
}());
exports.Loader = Loader;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ComponentDefinition = (function () {
    function ComponentDefinition(tagName, style, template, script) {
        this.tagName = tagName;
        this.style = style;
        this.template = template;
        this.script = script;
    }
    ComponentDefinition.prototype.generateRealComponent = function () {
    };
    return ComponentDefinition;
}());
exports.ComponentDefinition = ComponentDefinition;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentGenerator = (function () {
    function ComponentGenerator(sf, componentDefinitionPool) {
        this.componentDefinitionPool = componentDefinitionPool;
        this.sf = sf;
    }
    ComponentGenerator.prototype.scanComponent = function (element) {
        return __awaiter(this, void 0, void 0, function () {
            var compDef, attrs, i, child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        compDef = this.componentDefinitionPool[element.localName];
                        if (!compDef) return [3 /*break*/, 1];
                        attrs = element.attributes;
                        return [2 /*return*/, this.generate(element, compDef, attrs)];
                    case 1:
                        if (!(element.children && element.children.length > 0)) return [3 /*break*/, 6];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < element.children.length)) return [3 /*break*/, 5];
                        child = element.children[i];
                        return [4 /*yield*/, this.scanComponent(child)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, element];
                    case 6: return [2 /*return*/, element];
                }
            });
        });
    };
    ComponentGenerator.prototype.generate = function (tagElement, compDef, attrs) {
        return __awaiter(this, void 0, void 0, function () {
            function callInit() {
                if (vm_instance && vm_instance._init && typeof (vm_instance._init) === 'function') {
                    vm_instance._init();
                }
            }
            var randomAlias, template, tempFragment, htmlDom, vm_instance, debugComment, script, ViewModelClass, i, attr, eventName, setTarget, i, attr, j, child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (compDef.style) {
                            this.dealWithShadowStyle(compDef);
                        }
                        randomAlias = 'vm_' + Math.floor(10000 * Math.random()).toString();
                        template = compDef.template;
                        template = template.replace(new RegExp('this', 'gm'), randomAlias);
                        tempFragment = document.createElement('div');
                        tempFragment.insertAdjacentHTML('afterBegin', template);
                        if (tempFragment.children.length > 1) {
                            template = tempFragment.outerHTML;
                        }
                        tagElement.insertAdjacentHTML('beforeBegin', template);
                        htmlDom = tagElement.previousElementSibling;
                        htmlDom.classList.add(tagElement.localName);
                        if (compDef.script) {
                            debugComment = "//# sourceURL=" + tagElement.tagName + ".js";
                            script = compDef.script + debugComment;
                            ViewModelClass = new Function(script);
                            vm_instance = new ViewModelClass.prototype.constructor();
                            this.sf.registerViewModel(randomAlias, vm_instance);
                            vm_instance._dom = htmlDom;
                            vm_instance.dispatchEvent = function (eventType, data, bubbles, cancelable) {
                                if (bubbles === void 0) { bubbles = false; }
                                if (cancelable === void 0) { cancelable = true; }
                                var event = new CustomEvent(eventType.toLowerCase(), { "bubbles": bubbles, "cancelable": cancelable });
                                event['data'] = data;
                                vm_instance._dom.dispatchEvent(event);
                            };
                            for (i = 0; i < attrs.length; i++) {
                                attr = attrs[i];
                                if (attr.nodeName.search("sf-") !== -1) {
                                    if (attr.nodeName.search("sf-on") !== -1) {
                                        eventName = attr.nodeName.substr(5);
                                        vm_instance._dom.addEventListener(eventName, eval(attr.nodeValue));
                                    }
                                    else {
                                        setTarget = attr.nodeName.split("-")[1];
                                        vm_instance[setTarget] = eval(attr.nodeValue);
                                    }
                                }
                            }
                        }
                        for (i = 0; i < attrs.length; i++) {
                            attr = attrs[i];
                            if (attr.nodeName.search("sf-") === -1) {
                                htmlDom.setAttribute(attr.nodeName, attr.nodeValue);
                            }
                        }
                        tagElement.parentNode.removeChild(tagElement);
                        if (!(htmlDom.children && htmlDom.children.length > 0)) return [3 /*break*/, 5];
                        j = 0;
                        _a.label = 1;
                    case 1:
                        if (!(j < htmlDom.children.length)) return [3 /*break*/, 4];
                        child = htmlDom.children[j];
                        return [4 /*yield*/, this.scanComponent(child)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        j++;
                        return [3 /*break*/, 1];
                    case 4:
                        callInit();
                        return [2 /*return*/, htmlDom];
                    case 5:
                        callInit();
                        return [2 /*return*/, htmlDom];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ComponentGenerator.prototype.dealWithShadowStyle = function (compDef) {
        var stylesheet = compDef.style;
        var tagName = compDef.tagName;
        var head = document.getElementsByTagName('HEAD')[0];
        var style = document.createElement('style');
        style.type = 'text/css';
        var styleArray = stylesheet.split("}");
        var newArray = [];
        styleArray.forEach(function (value, index) {
            var newValue = value.replace(/^\s*/, "");
            if (newValue) {
                newArray.push(newValue);
            }
        });
        stylesheet = newArray.join("}\n" + "." + tagName + " ");
        stylesheet = "." + tagName + " " + stylesheet + "}";
        style.innerHTML = stylesheet;
        head.appendChild(style);
    };
    return ComponentGenerator;
}());
exports.ComponentGenerator = ComponentGenerator;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// sf.js